import { z } from "zod/v4";

import { ExpressionNode } from "./audiences";
import { UrlMatchList } from "./url-match";

export const TrafficConfigTargetingFilterList = [
  "equals",
  "contains",
  "startsWith",
  "endsWith",
  "doesNotEqual",
  "doesNotContain",
  "doesNotStartWith",
  "doesNotEndWith",
  "isNull",
  "isNotNull",
  "regex",
  "",
] as const;

export const ExperiencePageTargetingFilterTypeList = [
  "utm",
  "url",
  "device",
  "visitor",
  "jsExpression",
  "trafficSource",
  "country",
  "referrer",
  "cookie",
] as const;
export type TrafficConfigFilterType =
  (typeof ExperiencePageTargetingFilterTypeList)[number];

export const ExperiencePageTargetingDtoSchema = z.object({
  id: z.uuid(),
  /**
   * @deprecated Superseded by expression.
   */
  filter: z.enum(UrlMatchList).nullish(),
  /**
   * @deprecated Superseded by expression.
   */
  filterType: z.enum(ExperiencePageTargetingFilterTypeList).default("url"),
  /**
   * @deprecated Superseded by expression.
   */
  value: z.string(),
  /**
   * @deprecated Superseded by expression.
   */
  order: z.number(),
  expression: z.array(ExpressionNode).nullish(),
  experienceId: z.uuid().optional(),
});

export type ExperiencePageTargetingDto = z.infer<
  typeof ExperiencePageTargetingDtoSchema
>;

export const CreateExperiencePageTargetingDtoSchema =
  ExperiencePageTargetingDtoSchema.extend({
    experienceId: z.uuid().optional(),
  });
